module.exports = __webpack_public_path__ + "img/magento-security-services@2x.d717ed2f.webp";